export default function CookieBanner() {
  return null;
}